// Hook - konfiguracja Meta Embedded Signup + status polaczenia WhatsApp biezacego handlowca.
// GET /api/ui/sales-crm/whatsapp/embedded-signup/config
// Faza 7 - inbound-only (darmowe odbieranie wiadomosci, bez wysylki).

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';

export interface IGetWhatsappEmbeddedSignupConfigResponse {
  appId: string;
  configId: string;
  mode: 'production' | 'mock' | string;
  webhookUrl: string;
  isConnected: boolean;
  displayPhoneNumber: string | null;
  needsReconnect: boolean;
  connectedAt: string | null;
}

export const getWhatsappEmbeddedSignupConfigQueryKey = [
  'sales-crm-whatsapp',
  'embedded-signup',
  'config'
] as const;

const getWhatsappEmbeddedSignupConfig = (): Promise<IGetWhatsappEmbeddedSignupConfigResponse> =>
  axios.get('/sales-crm/whatsapp/embedded-signup/config');

export const useGetWhatsappEmbeddedSignupConfig = (
  options?: UseQueryOptions<IGetWhatsappEmbeddedSignupConfigResponse, IError>
) =>
  useQuery<IGetWhatsappEmbeddedSignupConfigResponse, IError>(
    getWhatsappEmbeddedSignupConfigQueryKey,
    () => getWhatsappEmbeddedSignupConfig(),
    {
      staleTime: 60 * 60 * 1000,
      ...options
    }
  );
